// src/lib/uniqueBy.ts
export function uniqueBy<T, K extends keyof any>(arr: T[], key: (v: T) => K): T[] {
  const seen = new Set<K>();
  const out: T[] = [];
  for (const v of arr) {
    const k = key(v);
    if (!seen.has(k)) { seen.add(k); out.push(v); }
  }
  return out;
}
